import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { IState } from '../../models/reducers/i-state.interface';

import { ROUTES } from 'constants/routes.constant';

import { isRoute } from '../../utils/route.utils';

import CircleSpinner from '../circleSpinner/CircleSpinner';
import './FullScreenLoadingSpinner.scss';

interface IFullScreenLoadingSpinnerProps {
  loading?: boolean;
  loaderVariant?: 'default' | 'circular';
  opaqueBackground?: boolean;
  noFadeIn?: boolean;
}

const FullScreenLoadingSpinner = ({
  loading = false,
  loaderVariant,
  opaqueBackground = false,
  noFadeIn = false,
}: IFullScreenLoadingSpinnerProps) => {
  const location = useLocation();
  const isLoading = useSelector(({ global }: IState) => !!global.pendingRequests.length || global.loading || loading);
  const loaderRef = useRef(null);

  const isCircularLoaderRoute = isRoute({
    pathname: location.pathname,
    routes: [ROUTES.EVENTS, ROUTES.PERIODICAL_STAKING],
    trailingSlash: true,
  });

  const effectiveLoaderVariant = loaderVariant || (isCircularLoaderRoute ? 'circular' : 'default');

  const classNames = [
    'full-screen-loading-spinner',
    opaqueBackground ? 'full-screen-loading-spinner--opaque' : '',
    effectiveLoaderVariant === 'circular' ? 'full-screen-loading-spinner--circular' : '',
  ];
  const loadingSpinnerStyle = noFadeIn ? { animation: 'none' } : {};

  return isLoading ? (
    <div style={loadingSpinnerStyle} className={classNames.join(' ')} ref={loaderRef}>
      <CircleSpinner size={64} />
    </div>
  ) : (
    <></>
  );
};

export default FullScreenLoadingSpinner;
